module.exports = __webpack_public_path__ + "img/maintenance_in-progress.d43e8219.svg";